import { format, parseISO, isValid } from "date-fns";

/** Parse ISO timestamp from API into a Date (handles missing timezone). */
export function parseAppDate(iso) {
  if (!iso) return null;
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  return isValid(d) ? d : null;
}

/** YYYY-MM-DD in the user's local timezone (fixes UTC day-shift bugs). */
export function localDateKey(iso) {
  const d = parseAppDate(iso);
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** e.g. 25 May 2026 */
export function formatAppDate(iso, pattern = "d MMM yyyy") {
  const d = parseAppDate(iso);
  return d ? format(d, pattern) : "—";
}

/** e.g. 25 May 2026, 3:45 PM */
export function formatAppDateTime(iso) {
  return formatAppDate(iso, "d MMM yyyy, h:mm a");
}

/** Short label for lists — e.g. 25 May, 3:45 PM */
export function formatAppDateShort(iso) {
  return formatAppDate(iso, "d MMM, h:mm a");
}

/** Today's date as YYYY-MM-DD for date inputs. */
export function todayInputDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
